import React from 'react';
import styled from 'styled-components';
import { Body1, Container } from '@ui';
import { SplashSectionWrapper } from './styles';

const RowFeaturesWrapper = styled.div`
  padding-top: 48px;
  margin-left: 10%;
`;
const RowFeatureWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr; /* Creates a row for each element */
  gap: 16px; /* Space between rows within a feature */

  border-top: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  padding: 36px 24px;

  width: 100%;
  max-width: 500px;
`;
const RowFeatureIconBorder = styled.div`
  border: 2px solid ${({ theme }) => theme.themeColors.text};
  border-radius: 5px;

  height: 40px;
  width: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
`;
const RowFeatureIconWrapper = styled.div`
  svg {
    fill: ${({ theme }) => theme.themeColors.text};

    height: 28px;
    width: 28px;
  }
`;
const RowFeatureNumberWrapper = styled.div`
  padding-left: 16px;
  font-weight: bold;

  * {
    font-size: 14px !important;
    line-height: 18px !important;
  }
`;
const RowFeatureTextWrapper = styled.div`
  * {
    line-height: 1.1 !important;
  }
`;

const LeftPanel = styled.div`
  max-width: 50%;
  padding-right: 80px;
`;

function RowFeature({ text, index, icon }) {
  return (
    <RowFeatureWrapper>
      <RowFeatureIconBorder>
        <RowFeatureIconWrapper>{icon}</RowFeatureIconWrapper>
      </RowFeatureIconBorder>
      <RowFeatureNumberWrapper>
        <Body1>0{index}</Body1>
      </RowFeatureNumberWrapper>
      <RowFeatureTextWrapper>
        <Body1>{text}</Body1>
      </RowFeatureTextWrapper>
    </RowFeatureWrapper>
  );
}

function Lock() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox=".2 -1 24 24">
      <path d="M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z" />
    </svg>
  );
}

function DocStorage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z" />
    </svg>
  );
}

function DataIngestion() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox=".3 -1 24 24">
      <path d="M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z" />
    </svg>
  );
}

function Workflow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -.5 24 24">
      <path d="M21 16V13C21 11.89 20.11 11 19 11H13V8H15V2H9V8H11V11H5C3.89 11 3 11.89 3 13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21M11 4H13V6H11V4M5 20H3V18H5V20M13 20H11V18H13V20M21 20H19V18H21V20Z" />
    </svg>
  );
}

function Quality() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 24 24">
      <path d="M20 17C21.1 17 22 16.1 22 15V4C22 2.9 21.1 2 20 2H9.5C9.8 2.6 10 3.3 10 4H20V15H11V17M15 7V9H9V22H7V16H5V22H3V14H1.5V9C1.5 7.9 2.4 7 3.5 7H15M8 4C8 5.1 7.1 6 6 6S4 5.1 4 4 4.9 2 6 2 8 2.9 8 4M17 6H19V14H17V6M14 10H16V14H14V10M11 10H13V14H11V10Z" />
    </svg>
  );
}

function Fence() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 2 24 24">
      <path d="M9 9V11H7V9H5V11H3V9H1V21H3V19H5V21H7V19H9V21H11V19H13V21H15V19H17V21H19V19H21V21H23V9H21V11H19V9H17V11H15V9H13V11H11V9H9M3 13H5V17H3V13M7 13H9V17H7V13M11 13H13V17H11V13M15 13H17V17H15V13M19 13H21V17H19V13Z" />
    </svg>
  );
}

function Cancel() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 24 24">
      <path d="M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M12 4C10.1 4 8.4 4.6 7.1 5.7L18.3 16.9C19.3 15.5 20 13.8 20 12C20 7.6 16.4 4 12 4M16.9 18.3L5.7 7.1C4.6 8.4 4 10.1 4 12C4 16.4 7.6 20 12 20C13.9 20 15.6 19.4 16.9 18.3Z" />
    </svg>
  );
}

const BackgroundWrapper = styled.div`
  background: ${({ theme }) => theme.colorPalette.primary.oak};
`;
const SectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  h3 {
    font-size: 48px;
    line-height: 64px;
    letter-spacing: -3px;
  }

  @media (max-width: 1300px) {
    ${LeftPanel} {
      padding-right: 40px;
    }
  }
  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 100px;

    height: auto;

    h3 {
      font-size: 48px;
      line-height: 58px;
      letter-spacing: -2px;
    }

    ${LeftPanel} {
      padding: 0;
      max-width: 1000px;
      width: 98%;
      margin: 0 auto;
    }
  }

  @media (max-width: 710px) {
    h3 {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -1px;
    }

    ${RowFeaturesWrapper} {
      margin-left: 8px;
    }
  }

  @media (max-width: 500px) {
    padding-left: 8px;
    padding-right: 8px;

    h3 {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -1px;
    }

    ${RowFeaturesWrapper} {
      margin-left: -8px;
    }
  }
`;

export const Security = () => {
  return (
    <BackgroundWrapper>
      <SplashSectionWrapper>
        <SectionWrapper>
          <div>
            <h3>Secure, compliant AI synthesis layer for financial institutions.</h3>
            <Container top={24}>
              <Body1>
                Seamlessly integrate your existing document stores, sellside research, CIMs, and other sources. Harness
                the power of artificial intelligence to connect the dots, and derive unique insights from millions of
                pages across multiple feeds.
              </Body1>
            </Container>
            <Container top={8}>
              <Body1>
                Streamline research, enhance decision-making, and vastly scale dealflow and idea generation.
              </Body1>
            </Container>
            <RowFeaturesWrapper>
              <RowFeature
                index={1}
                text={
                  'Secure ring-fencing with configurable information walls and compliance workflows. All client data is encrypted with industry standard TLS 1.2 in transit and AES-256 at rest'
                }
                icon={<Lock />}
              />
              <RowFeature
                index={2}
                text={'Continuous data ingestion with custom, automated analyses and reporting'}
                icon={<DataIngestion />}
              />
              <RowFeature index={3} text={'Agentic automation mirroring analyst workflows'} icon={<Workflow />} />
              <RowFeature index={4} text={'Exceptional quality and world-class analyst oversight'} icon={<Quality />} />
              {/*<RowFeature*/}
              {/*  index={5}*/}
              {/*  text={'All client data is encrypted with industry standard TLS 1.2 in transit and AES-256 at rest'}*/}
              {/*  icon={<Lock />}*/}
              {/*/>*/}
              <RowFeature
                index={5}
                text={
                  'We never train or fine-tune shared models on your data, so there’s no risk of it bleeding outside your environment'
                }
                icon={<Cancel />}
              />
            </RowFeaturesWrapper>
          </div>
        </SectionWrapper>
      </SplashSectionWrapper>
    </BackgroundWrapper>
  );
};
